import { LOCIZE_ERRORS_TRANSLATION_KEYS } from 'app-constants';
import type { GraphQLFormattedError } from 'graphql';
import type { AnyObject, GraphQLErrorExtended } from 'models';

type Validation = AnyObject | undefined;

export const getValidationMessage = (validation: Validation): string => {
  if (
    validation?.documents &&
    Array.isArray(validation.documents) &&
    validation.documents[0]
  ) {
    return LOCIZE_ERRORS_TRANSLATION_KEYS.validationErrorDocuments_1;
  }

  if (validation?.['documents.0']) {
    return LOCIZE_ERRORS_TRANSLATION_KEYS.validationErrorDocuments_2;
  }

  return LOCIZE_ERRORS_TRANSLATION_KEYS.validationError;
};

export const convertToGraphQLErrorsExtendedFormat = (
  graphQLErrors: readonly GraphQLFormattedError[],
) => {
  return graphQLErrors.map((error): GraphQLErrorExtended => {
    const code = error.extensions?.code || (error as any).code;
    const codeValue = typeof code === 'number' ? code : undefined;

    const validation = error.extensions?.validation;
    const validationValue =
      validation && typeof validation === 'object'
        ? (validation as AnyObject)
        : undefined;

    const extendedError: GraphQLErrorExtended = {
      message: error.message,
      locations: error.locations,
      path: error.path,
      extensions: error.extensions || {},
      nodes: undefined,
      source: undefined,
      positions: undefined,
      originalError: undefined,
      code: codeValue,
      validation: validationValue,
      toJSON: () => error,
      [Symbol.toStringTag]: 'GraphQLError',
      name: 'GraphQLError',
    };

    return extendedError;
  });
};
